/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy points are tracked separately in the Fantasy Points section.`)
};

const es_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los puntos de fantasía se registran por separado en la sección Puntos Fantasy.`)
};

const de_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-Punkte werden separat im Bereich Fantasy-Punkte verfolgt.`)
};

const nl_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantasy-punten worden apart bijgehouden in het gedeelte Fantasy-punten.`)
};

const fr_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les points fantasy sont suivis séparément dans la section Points Fantasy.`)
};

const it_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I punti fantasy sono tracciati separatamente nella sezione Punti Fantasy.`)
};

const pt_br2_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos fantasy são rastreados separadamente na seção Pontos Fantasy.`)
};

const pt_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pontos fantasy são rastreados separadamente na secção Pontos Fantasy.`)
};

const ja_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファンタジーポイントはファンタジーポイントセクションで別途追跡されます。`)
};

const zh_f1_standings_fantasy_since_2023 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梦幻积分在梦幻积分板块单独追踪。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_fantasy_since_2023 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_fantasy_since_2023(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_fantasy_since_2023", locale)
	if (locale === "en") return en_f1_standings_fantasy_since_2023(inputs)
	if (locale === "es") return es_f1_standings_fantasy_since_2023(inputs)
	if (locale === "de") return de_f1_standings_fantasy_since_2023(inputs)
	if (locale === "nl") return nl_f1_standings_fantasy_since_2023(inputs)
	if (locale === "fr") return fr_f1_standings_fantasy_since_2023(inputs)
	if (locale === "it") return it_f1_standings_fantasy_since_2023(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_fantasy_since_2023(inputs)
	if (locale === "pt") return pt_f1_standings_fantasy_since_2023(inputs)
	if (locale === "ja") return ja_f1_standings_fantasy_since_2023(inputs)
	return zh_f1_standings_fantasy_since_2023(inputs)
};